import FiveGridLine_NotchLineComponent from '@wix/thunderbolt-elements/src/components/FiveGridLine/viewer/skinComps/NotchLine/NotchLine.skin';


const FiveGridLine_NotchLine = {
  component: FiveGridLine_NotchLineComponent
};


export const components = {
  ['FiveGridLine_NotchLine']: FiveGridLine_NotchLine
};

